<template>
    <b-container>
      <b-row>
     <p>
        <i>{{ $t('Table.msg') }}</i>
      </p>
      <b-button variant="danger" :to="{name: 'Home'}">{{ $t('Table.homeLink') }}</b-button>
    </b-row>
  </b-container>
</template>

<script>
import {
  mapActions
} from 'vuex'

export default {
  created () {
    this.setTableNumber(this.$route.params.table)
    // navigate to home page
    this.$router.push({ name: 'Categories' })
  },
  methods: {
    ...mapActions(['setTableNumber'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Table.vue